// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-list-container","blocksContainer":"pages-list-blocksContainer","title":"pages-list-title"};